import { hygraphClient } from '@/lib/graphql-clients';
import { Discipline, DisciplineType, getSdk } from '@/lib/types';

const getAll = async (): Promise<Discipline[]> => {
  const sdk = getSdk(hygraphClient(false));
  return (await sdk.Disciplines()).disciplines as Discipline[];
};

const getByDisciplineType = async (
  disciplineType: DisciplineType
): Promise<Discipline[]> => {
  const sdk = getSdk(hygraphClient(false));
  const disciplines = (await sdk.Disciplines({ where: { disciplineType } }))
    .disciplines as Discipline[];

  return disciplines.filter(
    (discipline) => discipline?.disciplineType === disciplineType
  );
};

const JobCategoryPageDisciplinesService = {
  getAll,
  getByDisciplineType,
};

export default JobCategoryPageDisciplinesService;
